export function generateNonce(): string {
  if (crypto?.randomUUID) {
    return crypto.randomUUID();
  }

  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < 36; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }

  return result;
}
